import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Endpoints } from '../../Global/Endpoints';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from "react-redux";
import ErrorModal from '../Security/ErrorModal';
import { useNavigate } from "react-router-dom";
import { updateWhyHere } from "../../Redux/userReducer"; // Adjust path as needed
import { registrationUpdateWhyHere } from "../../Redux/registrationReducer"; // Adjust path as needed

const UpdateJourneySelection = ({ emailID }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]); 
  const [selectedJourney, setSelectedJourney] = useState('');
  const [modalMessage, setModalMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  //Get user data and registration data from Redux
  const userInfo = useSelector((state) => state.userData);
  const registrationData = useSelector((state) => state.registration.registrationData);
  const token = localStorage.getItem('AccessToken');

  //Check which data is available and select `WhyHere`
  const isEmpty = (obj) => Object.keys(obj).length === 0; // Utility function to check if an object is empty
  const userJourney = !isEmpty(registrationData) ? registrationData.WhyHere: userInfo.userData?.WhyHere; // Prioritize registrationData if available


  useEffect(() => {
    const fetchJourneyOptions = async () => {
      try {
        const params = { EmailID: userInfo.userData.EmailID || registrationData.EmailID, DeviceType: "PatientPortal" };
        const response = await axios.post(
          Endpoints.AppWhyHere,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        );

        if (response.data && Array.isArray(response.data)) {
          const isUserJourneyValid = response.data.some(option => option.AppWhyHere === userJourney);

          setOptions(response.data); 
          setSelectedJourney(isUserJourneyValid ? userJourney : response.data[0]?.AppWhyHere);
        }
      } catch (error) {
        console.error("Error fetching journey options:", error);
        setModalMessage("Failed to load journey options. Please try again.");
        setShowModal(true);
      } finally {
        setLoading(false);
      }
    };

    fetchJourneyOptions();
  }, [emailID, userJourney]);

  const handleRadioChange = (e) => {
    setSelectedJourney(e.target.value);
  };

  const handleSubmit = async () => {
    if (!selectedJourney) {
      setModalMessage("Please select a journey before submitting.");
      setShowModal(true);
      return;
    }
  
    try {
      const params = { 
        emailID: userInfo?.userData?.EmailID || registrationData.EmailID, 
        journey: selectedJourney, 
        DeviceType: "PatientPortal" 
      };
  
      await axios.post(
        Endpoints.UpdateJourneyStatus,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        { headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${token}` } }
      );
  
      //Update only the 'WhyHere' field in Redux
      !isEmpty(registrationData) ? dispatch(registrationUpdateWhyHere(selectedJourney)):dispatch(updateWhyHere(selectedJourney));
      
  
      setModalMessage("Journey selection updated successfully!");
      setShowModal(true);
    } catch (error) {
      console.error("Error updating journey:", error);
      setModalMessage("Failed to update journey. Please try again.");
      setShowModal(true);
    }
  };
  

  if (loading) {
    return <div>{t('load')}</div>;
  }

  const handleModalClose = () => {
    navigate(-1);
  };

  const handleBackClick = () => {
    navigate("/home");
  };

  return (
    <>
      <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
        <button onClick={handleBackClick} className="win-back-btn">
          <span><i className="bi bi-chevron-left"></i> {t('back')}</span>
        </button>
        <h2 className="page-heading">{t('healthplanupdatehl')}</h2>
      </div>
      <p>{t('healthplanupdatesh')}</p>

      <div className="col-md-12">
        {Array.isArray(options) && options.map((option, index) => (
          <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper" key={index}>
            <input
              type="radio"
              className="form-check-input radio-btn win-form-check-input"
              name="journeySelection"
              value={option.AppWhyHere}
              checked={selectedJourney === option.AppWhyHere}
              onChange={handleRadioChange}
            />
            <label className="multistep-form-radio-checkbox-label">
              {option.AppWhyHere}
            </label>
          </div>
        ))}

        <button className="win-btn-primary ms-5 mb-5" onClick={handleSubmit}>
          Submit
        </button>
        <ErrorModal show={showModal} message={modalMessage} onClose={handleModalClose} />
      </div>
    </>
  );
};

export default UpdateJourneySelection;